import {setResize} from '../../utils/set-resize';

export const accordion = (): void => {
  const accordionContainers = document.querySelectorAll('.c-accordion');

  accordionContainers.forEach((container) => {
    const items = Array.from(container.children).filter((child) => child.classList.contains('c-accordion__item'));

    items.forEach((item) => {
      let resizeTimeout: NodeJS.Timeout;
      const btn = item.querySelector('.c-accordion__btn');
      btn?.addEventListener('click', function () {
        item.classList.toggle('--open');
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          setResize();
        }, 1000);
      });
    });
  });
};
